import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { SimDataActivation } from './SimDataActivation';
import { SimDataSuccess } from './SimDataSuccess';
import { Meta } from '@core/Meta';
import { keyValueValidation } from '@utils/globalConstant';
import { useTitle } from '@context/Utils/Title';
export function ActivationStep1() {
  // Context
  const { step1SubStep, setShowActivationFooter } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();
  // META: page titles
  const { globalPageTitle, globalSuccessPageTitle } = getGlobalMetaTitles();
  const activationSimDataPageTitle = tA11yTranslate('ek_global_meta_title_sim_data').content;
  const isTranslationReady = keyValueValidation(activationSimDataPageTitle,'ek_global_meta_title_sim_data')

  // Determine the page title based on the current substep
  const getPageTitle = () => {
    if (step1SubStep === 1) {
      return `${globalPageTitle} - ${globalSuccessPageTitle}`;
    } else {
      return `${globalPageTitle} - ${activationSimDataPageTitle}`;
    }
  };

  useEffect(() => {
    const pageTitle = `${getPageTitle()}`;
    announceTitle(pageTitle);
  }, [step1SubStep, announceTitle]); // Re-run when substep changes

  // Hooks
  useEffect(() => {
    // Hide footer for below screens
    // 0.1.2.2 - registration step 1 - SIM data - success
    if (step1SubStep === 1) {
      setShowActivationFooter(false);
    } else {
      setShowActivationFooter(true);
    }
  }, [step1SubStep]);

  const renderStep1SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <SimDataActivation />;
      case 1:
        return <SimDataSuccess />;
      default:
        return <SimDataActivation />;
    }
  };

  // return renderStep1SubSteps(step1SubStep);
  return (
    <>
       <Meta title={getPageTitle()} key={`meta-key-${step1SubStep}`}/>
      {renderStep1SubSteps(step1SubStep)}
    </>
  );
}

export default ActivationStep1;
